import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  InfoButton,
  Legend,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import { Appearance } from "./Appearance"
import styles from "./Theme.module.scss"
import { Themes } from "./Themes"

import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useDebouncedUpdater,
  useUpdateDeviceSettings,
} from "src/hooks"

const polyglotPrefix = "pages.settings.display.themes."

export function Theme() {
  const polyglot = usePolyglot()

  const {
    currentUserId,
    currentDeviceSettings,
    currentFollow,
  } = useFollowedUsers()
  const deviceSettingsId = currentDeviceSettings.id
  const updatedAt = currentDeviceSettings.updated_at

  // TODO catch error and show toast
  const updateDeviceSettings = useUpdateDeviceSettings()
  const debouncedUpdateDeviceSettings =
    useDebouncedUpdater({ updater: updateDeviceSettings })

  const debouncedUpdateDeviceSettingsWithId = useCallback(
    (deviceSettings: Partial<DeviceSettings>) => debouncedUpdateDeviceSettings({
      id: deviceSettingsId,
      ...deviceSettings,
    }),
    [
      debouncedUpdateDeviceSettings,
      deviceSettingsId,
    ],
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.theme")}
      backRoutePath={currentFollow.is_self ? "/settings" : "/settings/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        <Appearance
          updatedAt={updatedAt}
          updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
        />

        <div>
          <Legend id="theme-label">
            {polyglot.t(`${polyglotPrefix}label`)}
            <InfoButton title={polyglot.t(`${polyglotPrefix}title`)}>
              {polyglot.t(`${polyglotPrefix}description`)}
            </InfoButton>
          </Legend>
          <div className={styles.selectContainer}>
            <Themes
              updatedAt={updatedAt}
              updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
            />
          </div>
        </div>
      </div>
    </PageTemplate>
  )
}
